// extracted by mini-css-extract-plugin
module.exports = {"main":"layout_main__WZYoE","header":"layout_header__bklZl"};